import React, { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import ClipLoader from "react-spinners/ClipLoader";
import OutletHead from '../../../../components/common/outlet-head';
import { useAuth } from '../../../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Skeleton from 'react-loading-skeleton';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../../../firebase';
import ToggleSwitch from '../../../../components/common/utils/toggle-switch';

function Reminders() {

  const { settings } = useAuth();
  let navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [isUpdating, setIsUpdating] = useState(false);
  const [reminderData, setReminderData] = useState({
    booking: false,
    dueDate: false,
    payment: false,
    newUpdates: false,
    updatedOn: null
  });

  useEffect(() => {
    if (settings) {
      settings.forEach(doc => {
        if (doc.id === 'reminders') {
          setReminderData(doc);
        }
      });

      setIsLoading(false);
    }
  }, [settings]);

  async function handleReminderData() {
    setIsUpdating(true);

    const tempData = { ...reminderData, updatedOn: new Date() };
    delete tempData.id;

    try {
      await updateDoc(doc(db, "Settings", 'reminders'), tempData);
      setIsUpdating(false);
      toast.success('Successfully Updated');
    } catch (error) {
      console.log('Updating Settings [Error] : ', error);
      setIsUpdating(false);
    }
  }

  return (
    <section className='section'>
      <OutletHead
        left={
          <div className='custom-header'>
            <h5 className='mb-0 fw-600'>Reminders</h5>
            <p className='mb-0 text-muted'>
              <small>Select which reminders are sent to you and your parties</small>
            </p>
          </div>
        }
        right={
          <div className='d-flex align-items-center'>
            <Button
              variant="light"
              type="submit"
              className='border py-2 btn-width me-3'
              onClick={() => navigate('/admin/dashboard')}
            >
              <span className='px-4'>Cancel</span>
            </Button>
            <Button
              disabled={settings ? reminderData === settings.find(x => x.id === 'reminders') : true}
              variant="primary"
              type="submit"
              className='py-2 btn-width'
              onClick={handleReminderData}
            >
              {
                isUpdating ?
                  <div className='d-flex align-items-center justify-content-center'>
                    <span className='me-2'>Saving</span>
                    <ClipLoader color='white' size={16} />
                  </div>
                  :
                  <span>Save Changes</span>
              }
            </Button>
          </div>
        }
      />
      <div className='form-wrapper px-3 border-top' >
        {
          isLoading ?
            <div className='row'>
              <div className='col-6 mt-3'>
                <Skeleton height={72} />
              </div>
              <div className='col-6 mt-3'>
                <Skeleton height={72} />
              </div>
              <div className='col-6 mt-3'>
                <Skeleton height={72} />
              </div>
              <div className='col-6 mt-3'>
                <Skeleton height={72} />
              </div>
            </div>
            :
            <div className='row'>
              <div className='col-6'>
                <div className='border overflow-hidden rounded mt-3 p-3'>
                  <div className='d-flex align-items-center justify-content-between'>
                    <div>
                      <p className='mb-0'>Booking</p>
                      <Form.Label className='mb-0'>
                        Sent updates about booking to party
                      </Form.Label>
                    </div>
                    <ToggleSwitch
                      checked={reminderData && reminderData.booking}
                      onChange={(event) => {
                        setReminderData({
                          ...reminderData,
                          booking: event.target.checked
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className='col-6'>
                <div className='border overflow-hidden rounded mt-3 p-3'>
                  <div className='d-flex align-items-center justify-content-between'>
                    <div>
                      <p className='mb-0'>Due Date</p>
                      <Form.Label className='mb-0'>
                        Send reminder to collect payments on time
                      </Form.Label>
                    </div>
                    <ToggleSwitch
                      checked={reminderData && reminderData.dueDate}
                      onChange={(event) => {
                        setReminderData({
                          ...reminderData,
                          dueDate: event.target.checked
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className='col-6'>
                <div className='border overflow-hidden rounded mt-3 p-3'>
                  <div className='d-flex align-items-center justify-content-between'>
                    <div>
                      <p className='mb-0'>Payment</p>
                      <Form.Label className='mb-0'>
                        Send payment collection information
                      </Form.Label>
                    </div>
                    <ToggleSwitch
                      checked={reminderData && reminderData.payment}
                      onChange={(event) => {
                        setReminderData({
                          ...reminderData,
                          payment: event.target.checked
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className='col-6'>
                <div className='border overflow-hidden rounded mt-3 p-3'>
                  <div className='d-flex align-items-center justify-content-between'>
                    <div>
                      <p className='mb-0'>New Updates & Advertisement</p>
                      <Form.Label className='mb-0'>
                        Sent new updates or advertisement to party
                      </Form.Label>
                    </div>
                    <ToggleSwitch
                      checked={reminderData && reminderData.newUpdates}
                      onChange={(event) => {
                        setReminderData({
                          ...reminderData,
                          newUpdates: event.target.checked
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
        }
      </div>
    </section>
  );
}

export default Reminders;
